/**
 * Dynamically injects the Cloudflare Turnstile API script into the document head.
 * Ensures that the script is only injected once per page.
 *
 * @param {string} siteKey - The Turnstile site key (if truthy, injects the script).
 */
export function injectTurnstileScript(siteKey) {
  if (siteKey && !document.getElementById('mta-turnstile-script')) {
    const script = document.createElement('script');
    script.id = 'mta-turnstile-script';
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    document.head.appendChild(script);
  }
}
